import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function Counter({
  from,
  to,
  suffix = '',
  duration = 2
}: {
  from: number;
  to: number;
  suffix?: string;
  duration?: number;
}) {
  const [count, setCount] = useState(from);
  const nodeRef = useRef<HTMLSpanElement | null>(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (!inView) return;
    let startTime: number | null = null;
    let animationFrame: number;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
      const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setCount(Math.floor(from + (to - from) * ease));
      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [inView, from, to, duration]);
  return <span ref={nodeRef} className="tabular-nums" data-id="element-21">
      {count.toLocaleString()}
      {suffix}
    </span>;
}
export function About() {
  const stats = [{
    from: 0,
    to: 160,
    suffix: '+',
    label: 'Obras entregadas'
  }, {
    from: 0,
    to: 75000,
    suffix: '+',
    label: 'm² habilitados'
  }, {
    from: 0,
    to: 35,
    suffix: '+',
    label: 'Clientes'
  }];
  return <section className="bg-white py-16 sm:py-24 lg:py-32 overflow-hidden" data-id="element-22">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-5xl mx-auto" data-id="element-24">
          {/* Badge */}
          <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2 text-sm font-bold text-blue-600" data-id="element-25">
            <span className="h-2 w-2 rounded-full bg-blue-600 animate-pulse" data-id="element-26" />
            QUIÉNES SOMOS
          </div>

          {/* Title */}
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900 mb-12 sm:mb-16" data-id="element-27">
            40 años redefiniendo <br data-id="element-28" />
            <span className="text-blue-600" data-id="element-29">
              el estándar constructivo.
            </span>
          </h2>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 sm:gap-16 max-w-5xl mx-auto" data-id="element-30">
            {stats.map((stat, index) => <motion.div key={stat.label} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="text-center" data-id="element-31">
                <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-2" data-id="element-32">
                  <Counter from={stat.from} to={stat.to} suffix={stat.suffix} duration={2} data-id="element-33" />
                </div>

                <div className="text-sm sm:text-base font-semibold text-gray-500 uppercase tracking-wider" data-id="element-34">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}